import { MessageSquare } from "lucide-react";
import { SalonCtaButtons } from "@/components/SalonCtaButtons";
import type { Salon } from "@/data/types";

interface Props {
  salon?: Salon | null;
}

export function EmptyReviewsState({ salon }: Props) {
  return (
    <div className="card-elev p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6">
      <MessageSquare className="text-brass-deep shrink-0" size={28} aria-hidden />
      <div className="flex-1 min-w-0">
        <div className="eyebrow">Omdömen</div>
        <p className="mt-1 text-sm text-foreground/80">
          Recensioner uppdateras. Under tiden kan du läsa fler omdömen på BokaDirekt eller Google.
        </p>
      </div>
      <SalonCtaButtons salon={salon} kinds={["book", "directions"]} ctaLocation="empty_reviews" />
    </div>
  );
}

export function InvalidReviewsState({ error }: { error?: unknown }) {
  return (
    <div className="card-elev p-6 md:p-8 border-destructive/30">
      <div className="eyebrow text-destructive">Dev: ogiltig recensionsdata</div>
      <p className="mt-1 text-sm text-foreground/80">
        En eller flera recensioner kunde inte renderas. Kör <code>bun run validate:data</code> för
        att se detaljer.
      </p>
      {error ? (
        <pre className="mt-3 text-xs text-muted-foreground overflow-auto max-h-40">
          {String(error instanceof Error ? error.message : error)}
        </pre>
      ) : null}
    </div>
  );
}
